function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import cn from 'classnames';
import T from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import _ from 'lodash/fp';
import NavProjectSelect from '../../../../../components/select/jobSelect/NavProjectSelect';
import useProjectsList from '../../../../../hooks/useProjectsList';
import { useShareLink2dMapMetadata } from '../../../../../hooks/useShareLinkParams';
import { alertError, setCurrentProject } from '../../../../../redux/actions';
import { profileSelectors } from '../../../../../redux/selectors/profile';
import routes from '../../../../../routes/constants';
import text from '../../../../../text';
import { client } from '../../../../../utilities/api';
import { getProjectLatestJob } from '../../../../../utilities/project';
import { isUserAnonymous } from '../../../../../utilities/user';
import ShareLinkNav from './ShareLinkNav';
var Map2DNav = function(param) {
    var className = param.className, showShareLink = param.showShareLink;
    var isAdmin = useSelector(profileSelectors.getIsAdmin);
    var dispatch = useDispatch();
    var history = useHistory();
    var location = useLocation();
    var jobId = location.pathname.split("".concat(routes.order.root, "/"))[1];
    var userProfile = useSelector(function(state) {
        return state.profileReducer;
    }).userProfile;
    var canGetJob = !_.isNil(jobId) && !_.isEmpty(userProfile) && !isUserAnonymous(userProfile);
    var _useState = _sliced_to_array(useState(null), 2), currentJob = _useState[0], setCurrentJob = _useState[1];
    var _useProjectsList = useProjectsList({
        isAdmin: isAdmin,
        filterPredicate: function(project) {
            var _project_jobs;
            return (project === null || project === void 0 ? void 0 : (_project_jobs = project.jobs) === null || _project_jobs === void 0 ? void 0 : _project_jobs.length) > 0;
        },
        deps: [
            canGetJob
        ]
    }), projects = _useProjectsList.projects, isLoading = _useProjectsList.isLoading;
    var _useAsyncFn = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.getJobById(jobId)
                    ];
                case 1:
                    data = _state.sent().data;
                    setCurrentJob(data);
                    return [
                        2
                    ];
            }
        });
    }), [
        canGetJob
    ]), 2), getJobState = _useAsyncFn[0], getJob = _useAsyncFn[1];
    useEffect(function() {
        if (!canGetJob) {
            return;
        }
        getJob();
    }, [
        canGetJob
    ]);
    useEffect(function() {
        if (getJobState.error) {
            console.error(getJobState.error.message);
            dispatch(alertError(getJobState.error.message));
        }
    }, [
        getJobState.error
    ]);
    useEffect(function() {
        if (!(currentJob === null || currentJob === void 0 ? void 0 : currentJob.project_id)) return;
        var project = _.find([
            'id',
            currentJob.project_id
        ], projects);
        if (project) {
            dispatch(setCurrentProject(project));
        }
    }, [
        currentJob
    ]);
    var map2DText = "".concat(text(isAdmin ? 'administrationMap2D' : 'map2D')).concat(jobId ? ':' : '');
    var metadata = useShareLink2dMapMetadata();
    return /*#__PURE__*/ React.createElement(Nav, {
        className: cn('Title', className)
    }, /*#__PURE__*/ React.createElement(Navbar, null, /*#__PURE__*/ React.createElement("span", null, map2DText), canGetJob && /*#__PURE__*/ React.createElement(NavProjectSelect, {
        projects: projects,
        isLoading: isLoading,
        onProjectChange: function(nextProject, prevProject) {
            var nextJob = getProjectLatestJob(nextProject);
            if (nextProject.id !== prevProject.id) {
                var _2dMapRoute = nextJob.mp_enabled ? routes.mp.job(nextJob.id) : routes.order.job(nextJob.id);
                history.push({
                    pathname: _2dMapRoute,
                    search: history.location.search
                });
                // TODO: fix this once map state is able to reload on project change
                window.location.reload();
            }
        }
    }), /*#__PURE__*/ React.createElement(ShareLinkNav, {
        show: showShareLink,
        metadata: metadata
    })));
};
Map2DNav.propTypes = {
    className: T.string
};
export default Map2DNav;
